<script lang="ts">
import { Dashboard } from "@/dashboard/dashboard.ts";
export default Dashboard;
</script>

<template v-if="pageLoader.loading.value">
    <base-header type="white" />
    <main
        class="layout__main dashboard-page documents dashboard__popup--open"
        :class="[routerModel.router.currentRoute.meta.mainClass]"
        id="mainWrapper"
    >
        <router-view />
        <router-view name="popup" />
    </main>
</template>
